'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lostItems = require('./remote/lostItems');

exports.default = {
    fetchLostItems: _lostItems.LostItems.fetchLostItems
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/lostItems.js
// module id = 9yZm
// module chunks = 60